import {
    Navigate,
    useLocation,
} from "react-router-dom";

import {
    useAuth,
} from "@/contexts/AuthContext";


export default function ProtectedRoute({
    children,
    roles,
}) {
    const {
        user,
        loading,
    } = useAuth();

    const location =
        useLocation();


    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center">
                <div className="animate-pulse text-muted-foreground">
                    ...
                </div>
            </div>
        );
    }


    if (!user) {
        return (
            <Navigate
                to="/login"
                state={{
                    from: location,
                }}
                replace
            />
        );
    }


    if (
        roles
        && !roles.includes(
            user.role
        )
    ) {
        return (
            <Navigate
                to="/"
                replace
            />
        );
    }


    const isSellerArea =
        user.role === "seller"
        && location.pathname.startsWith(
            "/seller"
        );

    const isVerificationPage =
        location.pathname
        === "/seller/verification";


    if (
        isSellerArea
        && !isVerificationPage
        && (
            user.seller_status
            !== "approved"
            || user.seller_verified
            !== true
        )
    ) {
        return (
            <Navigate
                to="/seller/verification"
                replace
            />
        );
    }


    return children;
}
